/* eslint-disable eqeqeq */
import { createSlice } from "@reduxjs/toolkit";

const combineSlice = createSlice({
  name: "combine",
  initialState: {
    error: "",
    loading: false,
    btnLoading: false,
    positionDrill: [],
    reload: false,
    positions: [],
    drills: [],
  },
  reducers: {
    setErrorCombine: (state, action) => {
      state.error = action.payload;
    },
    setLoadingCombine: (state, action) => {
      state.loading = action.payload;
    },
    setBtnLoading: (state, action) => {
      state.btnLoading = action.payload;
    },
    setPositionDrill: (state, action) => {
      state.positionDrill = action.payload;
    },
    setReload: (state, action) => {
      state.reload = action.payload;
    },
    setRemovePositionDrill: (state, action) => {
      const results = state.positionDrill.filter(
        (item) => item.id != action.payload,
      );
      state.positionDrill = results;
    },
    setAddPositionDrill: (state, action) => {
      const position = state.positions.filter(
        (item) => item.id == action.payload.data.positionId,
      );
      const drill = state.drills.filter(
        (item) => item.id == action.payload.data.drillId,
      );
      const response = action.payload.response;
      response.positionName = position[0].name;
      response.drillName = drill[0].name;
      state.positionDrill.push(response);
    },
    setUpdatePositionDrillCoachingTip: (state, action) => {
      const { id, coachingTip } = action.payload;
      state.positionDrill = state.positionDrill.map((item) =>
        item.id == id ? { ...item, coachingTip } : item,
      );
    },
    setPositions: (state, action) => {
      state.positions = action.payload;
    },
    setDrills: (state, action) => {
      state.drills = action.payload;
    },
  },
});

export const {
  setErrorCombine,
  setLoadingCombine,
  setBtnLoading,
  setPositionDrill,
  setReload,
  setRemovePositionDrill,
  setAddPositionDrill,
  setUpdatePositionDrillCoachingTip,
  setPositions,
  setDrills,
} = combineSlice.actions;
export default combineSlice.reducer;
